import React, { Component } from 'react'
import { Collapse } from 'reactstrap';
import Select from 'react-select';
import Firebase from 'firebase';

export default class overWriteDatasets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataset2: "",
            col: this.props.col,
            type: this.props.tipo,
            value: this.props.value
        }
        this.setColumnas = this.setColumnas.bind(this);
    }


    setColumnas(dataset_id) {
        var datasetsRef = Firebase.database()
            .ref('datasets')
            .child(localStorage.client_id)
            .child("tablas").child(dataset_id);
        datasetsRef.once('value')
            .then(resp => {
                var options = [];
                Object.values(Object.values(resp.val())[0]).map((c) => {
                    var tt = c;
                    tt = tt.substring(tt.indexOf("_") + 1);
                    var value = {
                        label: tt,
                        value: c
                    }
                    options.push(value);
                })
                this.setState({ datasets: options });
            })
    }

    render() {
        var options = [];
        var elements = [];
        var dropdown_elements = [];
        var all_elements = [];
        var element = {
            label: "Valor fijo",
            value: "value"
        }
        elements.push(element);
        if (this.props.data) {
            Object.values(this.props.data).map((f) => {
                Object.values(f.elements).map((m, index) => {
                    if (m.element_id === "DROPDOWNLIST") {
                        var dropdown = {
                            label: m.id,
                            value: m.id,
                            dataset: m.table
                        }
                        options.push(dropdown);
                    }
                    var element = {
                        label: m.id,
                        value: m.id
                    }
                    elements.push(element);
                })
            });
            dropdown_elements = options;
            all_elements = elements;
        }
        return (
            <div>
                <div className="form-group">
                    <label htmlFor="name" style={{ color: "#20a8d8" }}>Seleccione elemento:</label>
                    {
                        dropdown_elements ?
                            <Select
                                name="form-field-name"
                                className="Select Select--single is-clearable is-searchable has-value"
                                value={this.state.dropdown}
                                options={dropdown_elements}
                                onChange={(e) => {
                                    this.setState({ dropdown: e.value });
                                    this.setColumnas(e.dataset.dataset)
                                }}
                            />
                            :
                            ""
                    }
                </div>
                {
                    this.state.dropdown && this.state.datasets ?
                        <div className="form-group">
                            <label htmlFor="name" style={{ color: "#20a8d8" }}>Seleccione columna:</label>
                            <Select
                                name="form-field-name"
                                className="Select Select--single is-clearable is-searchable has-value"
                                value={this.state.col}
                                options={this.state.datasets}
                                onChange={(e) => {
                                    this.setState({ col: e.value });
                                }}
                            />
                        </div>
                        :
                        ""
                }
                {
                    this.state.col ?
                        <div className="form-group">
                            <label htmlFor="name" style={{ color: "#20a8d8" }}>Reemplazar por:</label>
                            <Select
                                name="form-field-name"
                                className="Select Select--single is-clearable is-searchable has-value"
                                value={this.state.value}
                                options={all_elements}
                                onChange={(e) => {
                                    this.setState({ value: e.value });
                                }}
                            />
                        </div>
                        :
                        ""
                }
                {
                    this.state.value === "value"
                        ?
                        <div className="form-group">
                            <label htmlFor="name" style={{ color: "#20a8d8" }}>Ingrese valor:</label>
                            <input type="text" className="form-control" id="name" value={this.state.value2} />
                        </div>
                        :
                        ""
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/forms/overWriteDatasets.js